import React from "react";
import { Inbox, Loader2 } from "lucide-react";

type EnquiryContentStateProps = {
    variant: "loading" | "empty";
    message: string;
};

export const EnquiryContentState = ({ variant, message }: EnquiryContentStateProps) => (
    <div className="rounded-2xl border border-dashed border-gray-300 bg-white px-6 py-16 text-center shadow-sm">
        {variant === "loading" ? (
            <Loader2 className="mx-auto h-10 w-10 animate-spin text-violet-500" />
        ) : (
            <Inbox className="mx-auto h-10 w-10 text-gray-300" />
        )}
        <p className="mt-4 text-sm font-medium text-gray-700">{message}</p>
        {variant === "empty" ? (
            <p className="mt-1 text-xs text-gray-400">Try changing filters or refresh the list.</p>
        ) : null}
    </div>
);
